import { get, isEmpty, each, parseInt } from 'lodash';
import { getDefaultLocaleCountry, getStore, isUserLoggedIn } from '../../../utils/utils';
import {
  QUICK_ORDER_URL,
  ORDER_CONFIRMATION_URL,
  QUOTE_CONFIRMATION_URL,
  CART_URL,
  ASIAN_COUNTRY,
} from '../../../global/constants';

import { TOTAL_CART_ITEM_LOWER_LIMIT } from '../../../constants';

export const getPageContextQuickOrderError = (props = {}) => {
  const { shoppingCartDataError, quickOrderDataError, confirmationError } = props;
  const pathVars = getDefaultLocaleCountry();
  const pageName = get(pathVars, 'template', '');
  if (pageName === CART_URL) {
    return shoppingCartDataError;
  }
  if (pageName === QUICK_ORDER_URL) {
    return quickOrderDataError;
  }
  if (pageName === ORDER_CONFIRMATION_URL || pageName === QUOTE_CONFIRMATION_URL) {
    return confirmationError;
  }
  return {};
};
export const getPageContextCartItemAdded = (props = {}) => {
  const { isCartItemAdded, isQuickOrderCartItemAdded, isConfirmationCartItemAdded } = props;
  const pathVars = getDefaultLocaleCountry();
  const pageName = get(pathVars, 'template', '');
  if (pageName === CART_URL) {
    return isCartItemAdded;
  }
  if (pageName === QUICK_ORDER_URL) {
    return isQuickOrderCartItemAdded;
  }
  if (pageName === ORDER_CONFIRMATION_URL || pageName === QUOTE_CONFIRMATION_URL) {
    return isConfirmationCartItemAdded;
  }
  return false;
};

export const getUserName = () => {
  const store = getStore();
  const isUserLogIn = isUserLoggedIn();
  const userDetails = get(store, ['global', 'globalData', 'userDetails'], {});
  const { firstName, lastName, mailingAddressCountryCode } = userDetails;
  let name = '';
  let isAsianCountry = false;
  if (isUserLogIn && !isEmpty(firstName) && !isEmpty(lastName)) {
    if (!isEmpty(mailingAddressCountryCode)) {
      each(ASIAN_COUNTRY, item => {
        if (item.toLowerCase() === mailingAddressCountryCode.toLowerCase()) {
          isAsianCountry = true;
        }
      });
    }
    if (isAsianCountry) {
      name = `${lastName} ${firstName}`;
    } else {
      name = `${firstName} ${lastName}`;
    }
  }

  return { isAsianCountry, name };
};

export const getMyAccountUserName = () => {
  const store = getStore();
  const isUserLogIn = isUserLoggedIn();
  const labels = get(store, ['global', 'globalData', 'labels'], {});
  const { myAccount, hello = '' } = labels;
  let userName = myAccount;
  const { name } = getUserName();
  if (isUserLogIn && !isEmpty(name)) {
    userName = `${hello}, ${name}`;
  }
  return userName;
};

export const getMyAccountDropdownUserName = () => {
  const { name } = getUserName();
  return name;
};

export const getCartTotalItems = (cartTotalItems, isConfirmation = false) => {
  let value = '';
  if (isEmpty(cartTotalItems) && !isConfirmation) {
    const totalItem = parseInt(cartTotalItems);
    if (totalItem > 0) {
      value =
        totalItem > TOTAL_CART_ITEM_LOWER_LIMIT
          ? `${TOTAL_CART_ITEM_LOWER_LIMIT + 1}+`
          : `${totalItem}`;
    }
  }
  return value;
};
